/* eslint-disable security/detect-object-injection */
/* eslint-disable no-plusplus */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { DateUtil } from '@xengage/gw-portals-util-js';
import {PolicyService, UserService} from 'gw-capability-gateway';
import { MLGatewayAccountBillingDetailsService } from 'gw-capability-gateway-billing'
import { platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { useModal } from '@jutro/components';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';
import { AccountService } from 'gw-capability-gateway-policy';

import classNames from 'classnames';
import MLPolicySummaryDetailsComponent from '../../Components/MLPolicySummaryDetailsComponent/MLPolicySummaryDetailsComponent';
import MLPolicyDocumentsComponent from '../../Components/MLPolicyDocumentsComponent/MLPolicyDocumentsComponent';
import MLCreateEditDocumentsPopup from '../MLCreateEditDocumentsPopup/MLCreateEditDocumentsPopup'
import MLDocumentsUpload from '../MLDocumentsUploadPopup/GatewayMLDocumentsUploadPopup';
import MLDocumentsUploadPopupMsg from '../MLDocumentsUploadPopup/MLDocumentsUploadPopup.messages';
import mlDocumentsUploadPopupMetadata from '../MLDocumentsUploadPopup/MLDocumentsUploadPopup.metadata.json5';
import metadata from './MLDocuments.metadata.json5';
import messages from './MLDocuments.messages';
import styles from './MLDocuments.module.scss';

import shareDocumentsPopupMetadata from './MLShareDocumentsPopup.metadata.json5';

const BUNDLED_TAB = 'bundled';
const POLICY_TAB = 'policy';
const ESIGN_TAB = 'esign';
const BILLING_TAB = 'billing';
const SENT_TAB = 'sent';
const CARDS_TAB = 'cards';
const TIMEFRAME_30_DAYS = '30days';
const TIMEFRAME_90_DAYS = '90days';
const TIMEFRAME_6_MONTHS = '6months';
const TIMEFRAME_1_YEAR = '1year';
const TIMEFRAME_3_YEARS = '3years';
const TIMEFRAME_5_YEARS = '5years';

const emailSubTypes = [
    'agent_of_record_change',
    'animal_liability_exclusion',
    'application',
    'association_affinity',
    'consent_to_rate',
    'hurricane_windstorm_deductible',
    'hurricane_windstorm_loss_mitigation',
    'medical_election_rejection',
    'mine_subsidence_offer_form',
    'mine_subsidence_rejection',
    'named_driver_exclusion_form',
    'notice_of_benefits',
    'one_time_eft_authorization',
    'payroll_authorization',
    'personal_property_exclusion',
    'pip_election_rejection',
    'private_structures_exclusion_form',
    'recurring_credit_or_debit_card_authorization',
    'recurring_eft_authorization',
    'request_for_name_change',
    'scheduled_value_onroof_ext',
    'statement_of_no_loss',
    'tcpa',
    'third_party_designee',
    'tort_form',
    'uim_election_rejection',
    'uim_stacking_rejection',
    'um_election_rejection',
    'um_stacking_rejection',
    'um_uim_election_rejection',
    'umpd_election_rejection',
    'windstorm_and_hail_exclusion',
    'confirmation_of_coverage',
    'confirmation_of_coverage_to_mortgagee',
    'business_use_confirmation_of_coverage',
    'certificate_of_insurance',
    'confirmation_of_driver',
    'coi_dmv_confirmation',
    'mortgagee_notice',
    'quote_proposal',
    'auto_identification_cards_mobile',
    'auto_identification_cards_pdf',
    'auto_identification_cards_temporary',
    'temporary_evidence_of_auto_insurance_nj_auto'
];

const MLDocuments = (props) => {
    const modalApi = useModal();
    const {
        policyDetailsData: {
            policyResponse: policyInfo
        },
        match: {
            params: { policyNumber }
        }
    } = props;

    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const ModalService = MLModalService();
    const [shareDocumentView, setShareDocumentView] = useState(
        {
            emailAddress1: "",
            faxNumber: '',
            print: false,
            distributionMethod: '',
            documentsToShare: []
        }
    );
    const newShareDocumentView = viewModelService.create(shareDocumentView, 'pc', 'metlife.edge.capabilities.gateway.account.dto.ShareDocumentDTOML');

    const [activeTab, setActiveTab] = useState(POLICY_TAB);
    const [allDocuments, setAllDocuments] = useState([]);
    const [bundledDocuments, setBundledDocuments] = useState([]);
    const [policyDocuments, setPolicyDocuments] = useState([]);
    const [pendingESignDocuments, setPendingESignDocuments] = useState([]);
    const [billingDocuments, setBillingDocuments] = useState([]);
    const [documentsYouSentUs, setDocumentsYouSentUs] = useState([]);
    const [idCardDocuments, setIdCardDocuments] = useState([]);
    const [filteredBundledDocuments, setFilteredBundledDocuments] = useState([]);
    const [filteredPolicyDocuments, setFilteredPolicyDocuments] = useState([]);
    const [filteredPendingESignDocuments, setFilteredPendingESignDocuments] = useState([]);
    const [filteredBillingDocuments, setFilteredBillingDocuments] = useState([]);
    const [filteredDocumentsYouSentUs, setFilteredDocumentsYouSentUs] = useState([]);
    const [filteredIdCardDocuments, setFilteredIdCardDocuments] = useState([]);
    const [docsThatCannotBeEmailed, setDocsThatCannotBeEmailed] = useState([]);
    const [ dayFilter, setDayFilter] = useState(TIMEFRAME_30_DAYS);
    const [portalSettings , setPortalSettings] = useState(null)
    const [ documentData, setDocumentData ] = useState([]);
    const [numberActionRequiredDocs, setNumberActionRequiredDocs] = useState(0);
    const [isUserRetentionAgent, setIsUserRetentionAgent] = useState(false);

    const getLeftMostNonEmptyTabAsActive = useCallback(() => {
        if (bundledDocuments.length > 0) {
            return BUNDLED_TAB;
        }
        if (policyDocuments.length > 0) {
            return POLICY_TAB;
        }
        if (pendingESignDocuments.length > 0) {
            return ESIGN_TAB;
        }
        if (billingDocuments.length > 0) {
            return BILLING_TAB;
        }
        if (documentsYouSentUs.length > 0) {
            return SENT_TAB;
        }
        if (idCardDocuments.length > 0) {
            return CARDS_TAB;
        }

        return POLICY_TAB;
    }, [billingDocuments, bundledDocuments, documentsYouSentUs, idCardDocuments, policyDocuments, pendingESignDocuments]);

    const addDays = (date, daysToAdd) => {
        date.setDate(date.getDate() + daysToAdd);
        return date;
    };

    const filterDocumentsByDate = (docs, filterDate) => {
        if (!docs) {
            return [];
        }
        if (!filterDate) {
            return docs;
        }
        return docs.filter((doc) => {
            const dateFilter = new Date(doc.dateModified)
            return dateFilter >= filterDate;
        });
    };

    const setFilterDate = useCallback((option) => {
        let filterDate;
        const currentDate = DateUtil.currentDate();
        if (option === TIMEFRAME_30_DAYS) {
            filterDate = addDays(currentDate, -30);
        } else if (option === TIMEFRAME_90_DAYS) {
            filterDate = addDays(currentDate, -90);
        } else if (option === TIMEFRAME_6_MONTHS) {
            filterDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6));
        } else if (option === TIMEFRAME_1_YEAR) {
            filterDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
        } else if (option === TIMEFRAME_3_YEARS) {
            filterDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 3));
        } else if (option === TIMEFRAME_5_YEARS) {
            filterDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 5));
        }
        return filterDate;
    },[]);

    const getDocumentsData = useCallback(() => {
        let docsData;
        switch (activeTab) {
            case BUNDLED_TAB:
                docsData = filteredBundledDocuments;
                break;
            case POLICY_TAB:
                docsData = filteredPolicyDocuments;
                break;
            case ESIGN_TAB:
                docsData = filteredPendingESignDocuments;
                break;
            case BILLING_TAB:
                docsData = filteredBillingDocuments;
                break;
            case SENT_TAB:
                docsData = filteredDocumentsYouSentUs;
                break;
            case CARDS_TAB:
                docsData = filteredIdCardDocuments;
                break;
            default:
                break;
        }
        return docsData;
    },[activeTab, billingDocuments, bundledDocuments, documentsYouSentUs, idCardDocuments, policyDocuments, pendingESignDocuments]);

    const updateFilteredDocsByDate = useCallback((selectedValue) => {
        const filterDate = setFilterDate(selectedValue);
        setFilteredBundledDocuments(filterDocumentsByDate(bundledDocuments, filterDate));
        setFilteredPolicyDocuments(filterDocumentsByDate(policyDocuments, filterDate));
        setFilteredPendingESignDocuments(filterDocumentsByDate(pendingESignDocuments, filterDate));
        setFilteredBillingDocuments(filterDocumentsByDate(billingDocuments, filterDate));
        setFilteredDocumentsYouSentUs(filterDocumentsByDate(documentsYouSentUs, filterDate));
        setFilteredIdCardDocuments(filterDocumentsByDate(idCardDocuments, filterDate));
        setDayFilter(selectedValue);
        setDocumentData(getDocumentsData());
    },[billingDocuments, bundledDocuments, documentsYouSentUs, getDocumentsData, idCardDocuments, policyDocuments, pendingESignDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredBundledDocuments(filterDocumentsByDate(bundledDocuments, filterDate));
    }, [dayFilter, bundledDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredPolicyDocuments(filterDocumentsByDate(policyDocuments, filterDate));
    }, [dayFilter, policyDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredPendingESignDocuments(filterDocumentsByDate(pendingESignDocuments, filterDate));
    }, [dayFilter, pendingESignDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredBillingDocuments(filterDocumentsByDate(billingDocuments, filterDate));
    }, [dayFilter, billingDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredDocumentsYouSentUs(filterDocumentsByDate(documentsYouSentUs, filterDate));
    }, [dayFilter, documentsYouSentUs, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredIdCardDocuments(filterDocumentsByDate(idCardDocuments, filterDate));
    }, [dayFilter, idCardDocuments, setFilterDate]);

    useEffect(() => {
        setActiveTab(getLeftMostNonEmptyTabAsActive())
    }, [bundledDocuments, policyDocuments, pendingESignDocuments, billingDocuments, documentsYouSentUs, idCardDocuments, getLeftMostNonEmptyTabAsActive])

    const getAndSetAllDocuments = async (number) => {
        let docsFromPc = [];
        try{
            docsFromPc = await PolicyService.getPolicyDocumentsForPolicy(number, authHeader);
        }catch(e){
            console.error(e);
            docsFromPc = [];
        }
        let docsFromBc = [];
        try{
            docsFromBc = await MLGatewayAccountBillingDetailsService.getBillingDocumentsForPolicy(number, authHeader);
        }catch(e){
            console.error(e);
            docsFromBc = [];
        }

        const allDocuments = [].concat(docsFromPc).concat(docsFromBc);
        setAllDocuments(allDocuments);
        setNumberActionRequiredDocs(allDocuments.filter((doc) => doc.isActionRequired_ML === true).length);
        return allDocuments;
    };

    const openAddNoteDialog = () => {
        const componentProps = {
            showHeader: false,
            uiProps: mlDocumentsUploadPopupMetadata.componentContent,
            actionBtnLabel: _.upperCase(translator(MLDocumentsUploadPopupMsg.continue)),
            cancelBtnLabel: MLDocumentsUploadPopupMsg.cancelModal,
            disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
            viewModelService,
            authHeader,
            CustomComponent: MLDocumentsUpload,
            overrideProps: {
                policyNumber: policyNumber,
                isAgent: true,
                policy: policyInfo,
                portalSettings
            },
            onSaveAction: () => {
                return false;
            },
            buttonType: 'secondary'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }

    const onUploadDocumentClicked = async () => {
        openAddNoteDialog();
    };

    const getCurrentTermPolicies = () => {
        const policies = [];
        const periodsOrderedFromLast = _.orderBy(policyInfo.periods, ['createTime_ML'], ['desc']);
        const flteredPeriods = periodsOrderedFromLast.find((period) => {
            const currentDate = new Date().setHours(0, 0, 0, 0);
            return currentDate >= MLLocalDateUtil.localDate2Date(period.effective_ML) && currentDate <= MLLocalDateUtil.localDate2Date(period.expiration_ML) 
        }) || policyInfo.latestPeriod;
        policies.push(flteredPeriods);
        return policies;
    };

    const fetchPortalSettings = async () => {
        const settings = await MLPortalSettingsService.getSettings(authHeader);

        setPortalSettings(settings)
    }

    useEffect(() => {
        async function fetchDocuments(){
            const allDocuments = await getAndSetAllDocuments(policyNumber)

            setBundledDocuments(allDocuments.filter((doc) => doc.isAccountLevelDocument_ML));
            setPolicyDocuments(allDocuments.filter((doc) => doc.isPolicyDocument_ML && !doc.isIDCard_ML));

            const pendingESignDocs = allDocuments.filter((doc) => doc.isPendingEsignDocument_Ext);

            const getUniqueInvitesByKeyMap = (arr, key) => {
                const map = new Map();

                arr.forEach((item) => {
                    map.set(item[key], item);
                });

                return Array.from(map.values());
            };

            setPendingESignDocuments(getUniqueInvitesByKeyMap(pendingESignDocs, 'signNowDocGroupInviteId_Ext'));
            setBillingDocuments(allDocuments.filter((doc) => doc.isBillingDocument_ML));
            setDocumentsYouSentUs(allDocuments.filter((doc) => doc.isDocumentYouSentUs_ML));
            setIdCardDocuments(allDocuments.filter((doc) => doc.isIDCard_ML));
            setDocsThatCannotBeEmailed(allDocuments.filter((doc) => {
                return !emailSubTypes.includes(doc.documentSubType_Ext);
            }));
        }

        async function getIsUserRetentionAgent () {
            const userProducerCodes = await UserService.getAvailableProducerCodesForCurrentUser(
                authHeader
            );
            setIsUserRetentionAgent(userProducerCodes && !!userProducerCodes.find((c) => c.isDocRetention_ML === true));
        }

        fetchDocuments();
        getIsUserRetentionAgent();
        fetchPortalSettings();
    }, []);

    const isFaxSelected = () => {
        if ((newShareDocumentView.distributionMethod.value) &&
            (newShareDocumentView.distributionMethod.value.code === 'fax_ml')) {
            return true;
        }
        return false;
    };

    const isUSPSSelected = () => {
        if ((newShareDocumentView.distributionMethod.value) &&
            (newShareDocumentView.distributionMethod.value.code === 'usps_ml')) {
            return true;
        }
        return false;
    };

    const isEmailSelected = () => {
        if ((newShareDocumentView.distributionMethod.value) &&
            (newShareDocumentView.distributionMethod.value.code === 'email')) {
            return true;
        }
        return false;
    };

    const retrieveErrorMessage = useCallback((baseErrorString) => {
        const indexOfMessageSplit = baseErrorString.indexOf('|');
        if (indexOfMessageSplit !== -1) {
            const fullErrorMessageString = baseErrorString.substring(0, indexOfMessageSplit);
            const errorMessageSplit = fullErrorMessageString.split('ErrorMessage: ');
            if (errorMessageSplit.length > 1) {
                return errorMessageSplit[1];
            }
        }
    }, []);

    const shareDocuments = async (error) => {
        const shareDocumentsPromise = AccountService.shareSelectedDocuments(newShareDocumentView.value, policyInfo.account.accountNumber, authHeader);
        ModalService.showProgressDialog(messages.sharingDocuments, shareDocumentsPromise);
        return shareDocumentsPromise.then(() => {
            MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_${activeTab}_Share Selected Documents`);
            return true;
        }).catch((e) => {
            error.message = retrieveErrorMessage(e.baseError);
            return false;
        })
    };

    const addRemoveDocToShare = (docID) => {
        const clonedDocumentView = _.cloneDeep(shareDocumentView);
        if (_.includes(shareDocumentView.documentsToShare, docID)) {
            _.remove(clonedDocumentView.documentsToShare, (id) => id === docID);
        } else {
            clonedDocumentView.documentsToShare.push(docID);
        }
        setShareDocumentView(clonedDocumentView);
    };

    const isTabActive = (tab) => {
        return tab === activeTab;
    };

    const showCreateEditDocuments = () => {
        const tagServiceFormName = `${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_${activeTab}_Create and Edit Document`;
        MLTagManagerService.sendFormStartEvent(tagServiceFormName);

        const componentProps = {
            title: messages.createAndEditDocument,
            CustomComponent: MLCreateEditDocumentsPopup,
            viewModelService,
            authHeader,
            showFooterOnCustomComponent: false,
            getOverrideProps: () => {
                return {
                    policyNumber: policyNumber,
                    tagServiceFormName,
                    ModalService,
                    emailSubTypes
                };
            }
        };

        const onCancel = () => {
            async function fetchDocuments(){
                const allDocuments = await getAndSetAllDocuments(policyNumber)
                
                setBundledDocuments(allDocuments.filter((doc) => doc.isAccountLevelDocument_ML));
                setPolicyDocuments(allDocuments.filter((doc) => doc.isPolicyDocument_ML && !doc.isIDCard_ML));
                setPendingESignDocuments(allDocuments.filter((doc) => doc.isPendingESignDocument_Ext));
                setBillingDocuments(allDocuments.filter((doc) => doc.isBillingDocument_ML));
                setDocumentsYouSentUs(allDocuments.filter((doc) => doc.isDocumentYouSentUs_ML));
                setIdCardDocuments(allDocuments.filter((doc) => doc.isIDCard_ML));
                setDocsThatCannotBeEmailed(allDocuments.filter((doc) => {
                    return !emailSubTypes.includes(doc.documentSubType_Ext);
                }))
            }
            
            fetchDocuments();
        }

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).finally(onCancel);
    };

    const openShareDocumentsPopup = () => {
        MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_${activeTab}_Share Selected Documents`);

        const hideEmailForDocType = docsThatCannotBeEmailed.some((doc) => {
            return newShareDocumentView.documentsToShare.value.includes(doc.publicID);
        });

        const moreThanFourDocsSelected = newShareDocumentView.documentsToShare.value.length > 4;

        newShareDocumentView.emailAddress1 = policyInfo.account.accountHolder.emailAddress1 || '';

        const mapAvailableValues = (values) => {
            const filteredValues = values.filter((value) => {
                const removeEmail = value.code === 'email' && (moreThanFourDocsSelected || hideEmailForDocType);
                const removeFax = value.code === 'fax_ml' && moreThanFourDocsSelected

                return !removeEmail && !removeFax
            })

            return filteredValues.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const availableDistValues = mapAvailableValues(newShareDocumentView.distributionMethod.aspects.availableValues);
        
        // eslint-disable-next-line prefer-destructuring
        newShareDocumentView.distributionMethod = availableDistValues[0];
        
        const error = {};
        let warning = {};

        if (moreThanFourDocsSelected && hideEmailForDocType) {
            warning = { message: translator(messages.emailSubTypeNotAllowedAndTooManyToEmailOrFax)}
        } else if (hideEmailForDocType) {
            warning = { message: translator(messages.emailSubTypeNotAllowed)}
        } else if (moreThanFourDocsSelected) {
            warning = { message: translator(messages.tooManyDocsToEmailOrFax)}
        }

        const componentProps = {
            title: messages.shareDocuments,
            uiProps: shareDocumentsPopupMetadata.pageContent,
            actionBtnLabel: platformMessages.mlSubmit,
            cancelBtnLabel: platformMessages.mlCancel,
            viewModel: newShareDocumentView,
            getOverrideProps: () => {
                return {
                    shareDocumentError: {
                        messageProps: {
                            error: _.get(error, 'message', '')
                        },
                        visible: !_.isEmpty(error)
                    },
                    shareDocumentWarning: {
                        messageProps: {
                            warning: _.get(warning, 'message', '')
                        },
                        visible: !_.isEmpty(warning)
                    },
                    distributionMethodRadio: {
                        availableValues: availableDistValues,
                        value: newShareDocumentView.distributionMethod.value.code
                    },
                    emailAddressRow: {
                        visible: isEmailSelected()
                    },
                    faxNumberRow: {
                        visible: isFaxSelected()
                    },
                    uspsDesc: {
                        visible: isUSPSSelected()
                    }
                };
            },
            onFieldValueChange: (value, path) => {
                _.set(newShareDocumentView, path, value);
            },
            onAsyncSaveAction: () => {
                return shareDocuments(error);
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const isDisabledDocumentShareButton = () => {
        return shareDocumentView.documentsToShare.length < 1;
    };    
    
    // Add keyboard event listener for tabs
    useEffect(() => {
        const tabList = document.getElementById('navigationSection');      

        if(tabList) {
            tabList.onkeydown = (e) => {
                if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                    const tabs = tabList.querySelectorAll(':scope [role="tab"]');
                    const tabsArray = Array.from(tabs);
                    
                    let tabFocus = tabsArray.findIndex((el) => {                        
                        return document.activeElement.id === el.id;
                    });

                    if (e.key === "ArrowRight") {
                        tabFocus++;
                        
                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                    // Move left
                    } else if (e.key === "ArrowLeft") {
                        tabFocus--;
                        
                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }

                    tabs[tabFocus].focus();
                }
            }
        }
    }); 

    const overrideProps = {
        policySummaryDetailsComponent: {
            policies: getCurrentTermPolicies(),
            dtoInfo: 'edge.capabilities.gateway.policy.dto.PolicyPeriodDTO',
            totalFees: policyInfo.totalChanges_Ext,
            itemizedFees: policyInfo.feesCosts_Ext,
            displayAlternativeTemplate: false,
            isDocumentsPage: true,
            numberActionRequiredDocs
        },
        navigationSection: {
            'aria-label': 'Documents',
            role: 'tablist'
        },
        bundledDocumentsContainer: {
            visible: bundledDocuments.length > 0,
            className: isTabActive(BUNDLED_TAB) ? 'active' : undefined
        },
        bundledDocuments: {
            onClick: () => setActiveTab(BUNDLED_TAB),
            mlTagManagerLinkClick: "Policy Summary_Documents_Bundled Documents",
            role: 'tab',
            'aria-selected': isTabActive(BUNDLED_TAB),
            tabindex: (isTabActive(BUNDLED_TAB)) ? '0' : '-1'
        },
        policyDocumentsContainer: {
            className: isTabActive(POLICY_TAB) ? 'active' : undefined
        },
        policyDocuments: {
            onClick: () => setActiveTab(POLICY_TAB),
            mlTagManagerLinkClick: "Policy Summary_Documents_Policy Documents",
            role: 'tab',
            'aria-selected': isTabActive(POLICY_TAB),
            tabindex: (isTabActive(POLICY_TAB)) ? '0' : '-1'
        },
        pendingESignContainer: {
            className: isTabActive(ESIGN_TAB) ? 'active' : undefined
        },
        pendingESignDocuments: {
            onClick: () => setActiveTab(ESIGN_TAB),
            mlTagManagerLinkClick: "Policy Summary_Documents_ESignature Documents",
            role: 'tab',
            'aria-selected': isTabActive(ESIGN_TAB),
            tabindex: (isTabActive(ESIGN_TAB)) ? '0' : '-1'
        },
        billingDocumentsContainer: {
            className: isTabActive(BILLING_TAB) ? 'active' : undefined
        },
        billingDocuments: {
            onClick: () => setActiveTab(BILLING_TAB),
            mlTagManagerLinkClick: "Policy Summary_Documents_Billing Documents",
            role: 'tab',
            'aria-selected': isTabActive(BILLING_TAB),
            tabindex: (isTabActive(BILLING_TAB)) ? '0' : '-1'
        },
        documentsYouSentUsContainer: {
            className: isTabActive(SENT_TAB) ? 'active' : undefined
        },
        documentsYouSentUs: {
            onClick: () => setActiveTab(SENT_TAB),
            mlTagManagerLinkClick: "Policy Summary_Documents_Documents You Sent Us",
            role: 'tab',
            'aria-selected': isTabActive(SENT_TAB),
            tabindex: (isTabActive(SENT_TAB)) ? '0' : '-1'
        },
        idCardsContainer: {
            className: isTabActive(CARDS_TAB) ? 'active' : undefined
        },
        idCards: {
            onClick: () => setActiveTab(CARDS_TAB),
            mlTagManagerLinkClick: "Policy Summary_Documents_ID Cards",
            role: 'tab',
            'aria-selected': isTabActive(CARDS_TAB),
            tabindex: (isTabActive(CARDS_TAB)) ? '0' : '-1'
        },
        bundledDocumentsTableContainer: {
            visible: bundledDocuments.length > 0,
            className: classNames('tab-pane', { active: isTabActive(BUNDLED_TAB) })
        },
        bundledDocumentsTable: {
            documents: filteredBundledDocuments,
            addRemoveDocToShare,
            hidePolicyNumber: true
        },
        policyDocumentsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(POLICY_TAB) })
        },
        policyDocumentsTable: {
            documents: filteredPolicyDocuments,
            addRemoveDocToShare,
            isUserRetentionAgent
        },
        pendingESignDocumentsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(ESIGN_TAB) })
        },
        pendingESignDocumentsTable: {
            documents: filteredPendingESignDocuments,
            addRemoveDocToShare,
            isUserRetentionAgent,
            isEsign: true
        },
        billingDocumentsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(BILLING_TAB) })
        },
        billingDocumentsTable: {
            documents: filteredBillingDocuments,
            addRemoveDocToShare,
            isUserRetentionAgent
        },
        documentsYouSentUsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(SENT_TAB) })
        },
        documentsYouSentUsTable: {
            documents: filteredDocumentsYouSentUs,
            addRemoveDocToShare
        },
        idCardDocumentsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(CARDS_TAB) })
        },
        idCardDocumentsTable: {
            documents: filteredIdCardDocuments,
            addRemoveDocToShare
        },
        shareSelectedDocumentsButton: {
            disabled: isDisabledDocumentShareButton(),
            onClick: openShareDocumentsPopup
        },
        createAndEditDocumentsButton: {
            onClick: showCreateEditDocuments
        },
        uploadDocumentsButton: {
            onClick: onUploadDocumentClicked
        },
        documentDaysDropdown: {
            value: dayFilter,
            onValueChange: (value) => updateFilteredDocsByDate(value)
        }
    };

    const resolvers = {
        resolveComponentMap: {
            MLPolicySummaryDetailsComponent,
            mlPolicyDocuments: MLPolicyDocumentsComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default MLDocuments;